/**
 * @file 产品价值
 * @author
 */

import React from 'react';
import advantage1 from './imgs/call-auth-advantage-completing.png';
import advantage2 from './imgs/call-auth-advantage-connect.png';
import advantage3 from './imgs/call-auth-advantage-trade.png';
import callAuthGuide from './imgs/call_auth_guide.svg';

import AuthButton from '../attest/authButton';

interface Props {
    title: string;
}
export default function Advantage(props: Props) {
    const data = [
        {
            img: advantage1,
            title: '提高接通率',
            content: '权威认证号码，增加可信度'
        },
        {
            img: callAuthGuide,
            title: 'guide_one',
            content: ''
        },
        {
            img: advantage2,
            title: '建立有效沟通',
            content: '触达更多潜客，提升外呼质量'
        },
        {
            img: callAuthGuide,
            title: 'guide_two',
            content: ''
        },
        {
            img: advantage3,
            title: '提升品牌形象',
            content: '高频次展现企业信息，提升企业形象'
        }
    ];
    return (
        <div className="advantage">
            <p className="common-title title">{props.title}</p>
            <div className="frame-card clear-float">
                {
                    data.map((item, index) => {
                        if (index % 2 !== 0) {
                            return (<div
                                className="card-item-guide"
                                key={item.title + index}
                            >
                                <img
                                    className="card-item-guide-img" src={item.img}/>
                            </div>);
                        }
                        return (<div
                            className="card-item"
                            key={item.title + index}
                        >
                            <img className="card-item-img" src={item.img}/>
                            <h2>{item.title}</h2>
                            <p>{item.content}</p>
                        </div>);
                    })
                }
            </div>
            <AuthButton
                {...props}
                name="了解更多价值"/>
        </div>
    );
}
